module.exports = __webpack_public_path__ + "static/media/building8.967f504a.svg";